import { useCallback } from 'react'
import { TopicTextWrapper, Topics, UploaderInfoElement, UploaderName, VideoTitle } from './Styled'
import { useNavigateTo } from 'hooks/useNavigateTo'

interface Topic {
  text: string
  params: any
}

interface UploaderInfoProps {
  uploaderId?: string
  uploader?: string
  videoName?: string
  topics?: Topic[]
  [key: string]: any
}

const UploaderInfo = ({ uploaderId = '', uploader = '', videoName = '', topics = [], ...props }: UploaderInfoProps) => {
  const { navigateToViewUploader } = useNavigateTo()
  const openUploaderPage = useCallback(
    (ev: React.MouseEvent) => {
      ev.preventDefault()
      ev.stopPropagation()
      navigateToViewUploader({
        uploaderId,
      })
    },
    [navigateToViewUploader, uploaderId]
  )

  const { navigateToViewMore } = useNavigateTo()

  const onClick = (text: string, params: any) => {
    navigateToViewMore({
      showAd: false,
      headerTitle: text,
      type: 'short',
      params,
    })
  }

  return (
    <UploaderInfoElement {...props}>
      {topics.length > 0 && (
        <Topics>
          <TopicTextWrapper>
            {topics.map((t, index) => (
              <span
                key={index}
                onClick={() => {
                  onClick(t.text, t.params)
                }}
              >
                {t.text}
              </span>
            ))}
          </TopicTextWrapper>
        </Topics>
      )}
      <UploaderName onClick={openUploaderPage}>{uploader}</UploaderName>
      <VideoTitle>{videoName}</VideoTitle>
    </UploaderInfoElement>
  )
}

export default UploaderInfo
